import React, { Fragment, useEffect, useState } from "react";
import T from "prop-types";
import styled from "styled-components/macro";
import TextInput from "commons/components/TextInput";
import Typography from "commons/components/Typography";
import Flexbox from "commons/components/Flexbox";
import Divider from "commons/components/Divider";
import Checkbox from "commons/components/Checkbox";
import Icon from "commons/components/Icon";
import Popover from "commons/components/Popover";
import AddButton from "commons/components/AddButton";
import Loader from "commons/components/Loader";
import Tag from "commons/components/Tag";
import InputBase from "commons/components/InputBase";
import { useTagGroups, useTagGroupsDispatch } from "App/contexts/TagGroupsContext";
import EmptyState from "commons/components/EmptyState";
import noTagsImage from "commons/images/emptyState/tags.svg";
import noSearchResultsImage from "commons/images/emptyState/searchResults.svg";
import callLocalStorage from "commons/util/callLocalStorage";
import { useTranslation } from "react-i18next";
import { getNextId, getTagGroupColor } from "commons/util/helpers";
import callApi from "commons/util/callApi";
import TagCreatePopoverContent from "App/Recipes/Editor/components/TagInput/TagCreatePopoverContent";
import TagInputPopoverContent from "./TagInputPopoverContent";

const Wrap = styled.div`
  position: relative;
  height: 480px;
  width: 376px;
`;

const Box = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 45px);
  overflow: auto;
  background-color: var(--neutral-200);
  border-radius: var(--border-radius-1) var(--border-radius-1) 0 0;
`;

const InputBaseStyled = styled(InputBase)`
  .shell {
    height: auto;
    padding: 8px;
  }
`;

const AddButtonSmall = styled(AddButton)`
  padding-top: 4px;
  padding-bottom: 4px;
`;

function TagInput({ className, selectedTags, tagInputPopoverProps }) {
  const { t } = useTranslation();

  return (
    <Popover
      className={className}
      placement="bottom-start"
      trigger={
        <InputBaseStyled
          label={t("Tags.Tags")}
          isShell
          value={
            <Flexbox gap={8} alignItems="center" flexWrap="wrap">
              {selectedTags.map(tag => (
                <Tag key={tag.id} icon={tag.icon} label={tag.label} color={tag.color} />
              ))}
              <AddButtonSmall>{t("Tags.AddTag")}</AddButtonSmall>
            </Flexbox>
          }
        />
      }
      content={<TagInputPopoverContent {...tagInputPopoverProps} />}
    />
  );
}

TagInput.propTypes = {
  className: T.string,
  selectedTags: T.array,
  tagInputPopoverProps: T.instanceOf(TagInputPopoverContent.propTypes),
};

export default TagInput;
